import { Box, IconButton, Tooltip } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import React from "react";
const ChatItem = ({
  item,
  activeSessionId,
  onSelectItem,
  handleMenuClick,
  groupId = null,
}) => {
  const isClicked = activeSessionId === item.session_id;
  const chatTitle = item.title || "Untitled Chat";
  const shouldShowTooltip = chatTitle.length > 29;

  const formatChatDate = (isoString) => {
    if (!isoString) return "";
    try {
      const dateObj = new Date(isoString);
      return dateObj
        .toLocaleString("en-US", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
        .toUpperCase();
    } catch (e) {
      return "";
    }
  };

  return (
    <Tooltip
      title={chatTitle}
      placement="right"
      enterDelay={600}
      disableHoverListener={!shouldShowTooltip}
      slotProps={{
        tooltip: {
          className: "chat-tooltip",
        },
      }}
    >
      <Box
        onClick={() => onSelectItem && onSelectItem(item.session_id)}
        className={`history-item ${isClicked ? "clicked" : ""}`}
      >
        <Box className="history-text-container">
          <Box className="history-item-title">{chatTitle}</Box>
          <Box className="history-item-date">
            {formatChatDate(item.created_at)}
          </Box>
        </Box>

        <IconButton
          size="small"
          className="history-more-btn"
          onClick={(e) => handleMenuClick(e, item, "chat", groupId)}
        >
          <MoreVertIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export default ChatItem;
